import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { Theme } from '../enums/theme.enum';
import { USER_CONTEXT } from '../tokens/user-context.token';

@Injectable({
	providedIn: 'root',
})
export class ThemeService {
	private userContext = inject(USER_CONTEXT);

	currentTheme = computed(() => {
		return this.userContext.user()?.theme;
	});

	isDark = signal(false);

	private readonly mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
	private readonly listener = () => this.updateClassList(this.currentTheme() ?? Theme.LIGHT);

	manualTheme = signal<Theme | undefined>(undefined);

	constructor() {
		effect((onCleanup) => {
			const theme = this.manualTheme() ?? this.currentTheme();
			if (theme) {
				if (theme === Theme.SYSTEM) {
					this.mediaQuery.addEventListener('change', this.listener);
					onCleanup(() => this.mediaQuery.removeEventListener('change', this.listener));
				}
				this.updateClassList(theme);
			}
		});
	}

	applyThemeToDom(theme: Theme | undefined): void {
		this.manualTheme.set(theme);
	}

	private updateClassList(theme: Theme) {
		const isDark = theme === Theme.SYSTEM ? this.mediaQuery.matches : theme === Theme.DARK;
		this.isDark.set(isDark);

		const htmlElement = document.documentElement;
		htmlElement.classList.toggle('dark', isDark);
	}
}
